import { useDatePickerContext } from '../DatePickerContext/DatePickerContext.js';

var useDatePickerDay = function (_a) {
    var minimal = _a.minimal, abbr = _a.abbr, full = _a.full;
    var size = useDatePickerContext().size;
    return {
        props: {
            title: full,
            size: size,
            children: size === "sm" ? minimal : abbr,
        },
    };
};

export { useDatePickerDay };
//# sourceMappingURL=useDatePickerDay.js.map
